import { Component } from 'preact'
import cx from 'classnames'

import { birmanize } from 'lib/textHelper'
import { moscowifyLocal } from '../../calendar/timezoneUtils'

import { Heading2, Heading3, TextNode } from '../../textNodes'

const Spotlight = ({ children }) => (
  <div className="newPaybarOverlay-spotlight">
    { children }
  </div>
)

export default class NewPaybarOverlayVacancy extends Component {
  get heading() {
    const key = this.isJustSubscribed ? 'headingSubscribed' : 'headingUpdated'

    return I18n.t(`newPaybar.successScreen.vacancy.self.${key}`)
  }

  get text() {
    return I18n.t('newPaybar.successScreen.vacancy.self.text')
  }

  get accessText() {
    const { email } = this.props
    const date = birmanize(moscowifyLocal(new Date(this.vacancy.endsAt)), { format: 'dateOnly' })

    return I18n.t('newPaybar.successScreen.vacancy.self.accessText', { email, date })
  }

  get isAuthenticated() {
    return this.props.isUserAuthenticated
  }

  get isJustSubscribed() {
    return !this.props.hasUpdatedSubscription
  }

  get vacancy() {
    return this.props.subscription.lastPublishedVacancy
  }

  render() {
    const classNameOverlayLock = cx('newPaybarOverlay-lock', { is__disabled: this.isAuthenticated })

    return (
      <div className="newPaybarOverlay-content">
        <div className="newPaybarOverlay-message">
          <Heading2 html={ this.heading } />
          { this.isJustSubscribed && <TextNode html={ this.text } /> }
        </div>

        <Spotlight>
          <Heading3>{ this.vacancy.title }</Heading3>
          <TextNode className="bureauserif">{ this.vacancy.jobLocation }</TextNode>
        </Spotlight>

        { this.isAuthenticated &&
          <div className="newPaybarOverlay-access">
            { this.isSelfUnauthenticated &&
              <span className={ classNameOverlayLock }>
                { I18n.t('newPaybar.successScreen.lock') }
              </span>
            }
            <TextNode html={ this.accessText } />
          </div>
        }

        { !this.isAuthenticated &&
          <div className="newPaybarOverlay-stub"></div>
        }
      </div>
    )
  }
}
